import type {
  GenericCSVExportConfig,
  GenericCSVExportParams,
} from '@/domains/shared/csvExport.entity';
import type { GenericCSVExportRepository } from '@/domains/shared/csvExport.repository';

/**
 * UseCase para exportar datos genéricos a formato CSV
 *
 * Responsabilidades:
 * - Recibir datos tabulares de cualquier tipo
 * - Aplicar configuración por defecto (delimitador, headers)
 * - Delegar la generación del CSV al repositorio especializado
 */
export class ExportGenericCSVUseCase {
  constructor(
    private readonly csvExportRepository: GenericCSVExportRepository,
  ) {}

  /**
   * Ejecuta la exportación de datos a CSV
   * @param params - Parámetros de exportación (datos y configuración opcional)
   */
  async execute<T>(params: GenericCSVExportParams<T>): Promise<void> {
    const { data, config = {} } = params;

    const enhancedConfig: GenericCSVExportConfig<T> = {
      delimiter: ';',
      includeHeaders: true,
      ...config,
    };

    await this.csvExportRepository.exportToCSV({
      data,
      config: enhancedConfig,
    });
  }
}
